// @flow
import React from 'react'
import DatetimePicker from 'react-datetime'
import classNames from 'classnames'
import Select from 'react-select/lib/Select'
import I18n from 'i18n-react'

import DateTime from './DateTime'

// core
import moment from '../../Moment'
import { renderDate } from '../../DateTimeFunctions'

// types
import type { DefaultFormFieldState, DefaultFormFieldType } from './AbstractFormField'

type DateTimeSelectProps = DefaultFormFieldType & {
  domain: {
    _type: string,
    pattern?: string,
    minDate?: string,
    maxDate?: string
  },
  relative?: boolean,
  value?: Date,
}

type SelectedValue = {
  [key: string]: string
}

type DateTimeSelectState = DefaultFormFieldState & {
  editCompleted: boolean,
  selectedValue: SelectedValue
}

export default class DateTimeSelect extends DateTime<DateTimeSelectProps, DateTimeSelectState> {

  handleOnSelectChange = (value: SelectedValue) => {
    if (value) {
      this.handleOnBlur(moment(value.value, 'YYYY-MM-DDTHH:mm'))
    } else {
      this.props.onChange('')
    }
  }

  render() {

    if (this.props.textMode) {
      return <span>{renderDate(this.props.value, this.state.editCompleted)}</span>
    }

    const classes = ['form-control']
    const wrapperClasses = ['react-datepicker']
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
      wrapperClasses.push('is-invalid')
    }

    let startDateFrom = moment()
    if (typeof this.props.relative === 'string' && this.props.formData && this.props.formData[this.props.relative]) {
      startDateFrom = moment(this.props.formData[this.props.relative])
    }

    const options = []
    for (let days = 1; days <= 7; days++) {
      const day = moment(startDateFrom).add(days, 'days').startOf('day')
      options.push({
        label: I18n.translate('general.dateTimeSelect', { context: days, date: day.format('DD.MM.YYYY') }),
        value: day.format('YYYY-MM-DDTHH:mm')
      })
    }

    return ([
      <div className='d-inline-block w-100 mb-3' key={`dateTimeSelect-${this.props.name}-select`}>
        <div className='d-block'>
          <div className='react-select'>
            <Select
              clearAllText={I18n.translate('stringEnum.clearAllText')}
              clearValueText={I18n.translate('stringEnum.clearValueText')}
              noResultsText={I18n.translate('stringEnum.noResultsText')}
              onChange={this.handleOnSelectChange}
              options={options}
              placeholder={I18n.translate('stringEnum.placeholder')}
              searchPromptText={I18n.translate('stringEnum.searchPromptText')}
              value={this.props.value || null}
              clearable={false}
            />
          </div>
        </div>
      </div>,
      <div className={classNames(wrapperClasses)} key={`dateTimeSelect-${this.props.name}-input`}>
        <DatetimePicker
          closeOnSelect
          inputProps={{
            className: classNames(classes),
            id: this.props.id,
            name: this.props.name,
            readOnly: !this.props.enabled,
          }}
          isValidDate={this.handleIsValidDate}
          locale='cs-CZ'
          onBlur={this.handleOnBlur}
          onChange={this.handleOnChange}
          strictParsing
          value={this.state.value}
        />
        {this.renderError()}
      </div>
    ])
  }
}
